import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../constants/stage-css-variables';
import { CANVAS, HORIZONTAL_ANCHOR, VERTICAL_ANCHOR } from '../constants/template-builder';
import type { HorizontalAnchorT, VerticalAnchorT } from '../types/annotations.type';
export function getScaledNodeOffset(): string {
  return `${CANVAS.NODE_RADIUS + CANVAS.NODE_LABEL_GAP}px * var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE})`;
}
export function getVerticalAnchor(y: number, canvasHeight: number): VerticalAnchorT {
  return y > canvasHeight * CANVAS.EDGE_FLIP_THRESHOLD ? VERTICAL_ANCHOR.TOP : VERTICAL_ANCHOR.BOTTOM;
}
export function getHorizontalAnchor(x: number, canvasWidth: number): HorizontalAnchorT {
  return x > canvasWidth * CANVAS.EDGE_FLIP_THRESHOLD ? HORIZONTAL_ANCHOR.RIGHT : HORIZONTAL_ANCHOR.LEFT;
}